import { useAuthentication } from '@cascade/react/authentication';
import { AuthenticationGate } from '@cascade/react-dom/authentication';
import type { TSessionGateProps } from './SessionGate.types.ts';
import { PROJECT_ID_PARAM } from '#config/index.ts';
import { SessionPending } from '#views/session-pending/index.ts';
import { SignIn } from '#views/sign-in/index.ts';

const transientParams = [PROJECT_ID_PARAM];

export const SessionGate = ({ children }: TSessionGateProps) => {
  const { status } = useAuthentication();

  return (
    <AuthenticationGate
      loading={<SessionPending status={status} />}
      unauthenticated={<SignIn />}
      transientParams={transientParams}
    >
      {children}
    </AuthenticationGate>
  );
};
